import React from 'react';
import {AddHour} from './AddHour';
import PropTypes from 'prop-types';
import {AddMinute} from './AddMinute';
import {StartTimer} from './StartTimer';
import {splitTime} from '../Timer.utils';
import {SubtractHour} from './SubtractHour';
import className from '../style.module.scss';
import {SubtractMinute} from './SubtractMinute';
import {TimerBase, StartButton} from '../TimerImages';

export function TimerControl(props) {
  const format = (value) => (value >= 10 ? `${value}` : `0${value}`);

  const [hour, minute, second] = splitTime(props.time).map(format);

  return (
    <div className={className.timerControl}>
      <TimerBase className={className.timerBase} />
      <p className={className.timerHH}>HH</p>
      <p className={className.timerMM}>MM</p>
      <p className={className.timerSS}>SS</p>
      <p className={className.timerTime}>
        <span>{hour}</span>:<span>{minute}</span>:<span>{second}</span>
      </p>
      <AddHour
        time={props.time}
        setTime={props.setTime}
        disabled={props.disabled}
      />
      <SubtractHour
        time={props.time}
        setTime={props.setTime}
        disabled={props.disabled}
      />
      <AddMinute
        time={props.time}
        setTime={props.setTime}
        disabled={props.disabled}
      />
      <SubtractMinute
        time={props.time}
        setTime={props.setTime}
        disabled={props.disabled}
      />
      <StartTimer startTimer={props.startTimer} disabled={props.disabled} />
    </div>
  );
}

TimerControl.propTypes = {
  /**
   * Time value set on the timer
   */
  time: PropTypes.instanceOf(Date),
  /**
   * Function to set timevalue
   */
  setTime: PropTypes.func,
  /**
   * Function to start timer
   */
  startTimer: PropTypes.func,
  /**
   * Boolen to disable buttons
   */
  disabled: PropTypes.bool,
};
